export default {
    CDN: "https://qncdn.redgezi.cn/"
}